import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-navy text-white" data-testid="auth-loading">
        <div className="text-sm tracking-[0.2em] uppercase text-cyan animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
